module.exports = __webpack_public_path__ + "img/logo-white.abad022a.png";